// /* eslint-disable */
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    SEARCH_LAYER,
    SEARCH_LIST_INSERT,
    SEARCH_LAYER_TAB,
    SEARCH_LAYER_TAB_VIEW,
    SEARCH_LATEST_DELETE,
    SEARCH_WORD,
    SEARCH_LIST_FOCUS_CLEAR,
    SEARCH_AUTO_LIST_INSERT,
    SEARCH_POPULAR_LIST_INSERT,
} from '../../libs/reducer';
import OutSide from './outSide';
import { setCookie, getCookie } from 'basic/common/cookie';
import { useLocation } from "react-router";

const AutoFrame = ({ onSearch }) => {
    const {
        searchLayer,
        searchList,
        popularList,
        searchLayerTab,
        searchLatestDelete,
        searchLayerTabView,
        autoList,
        // searchWord,
        searchWordHighlight,
    } = useSelector((state) => state.search);
    const dispatch = useDispatch();
    const {search} = useLocation()

    useEffect(() => {
        document.addEventListener('keydown', searchListPrev, false);

        return () => {
            document.removeEventListener('keydown', searchListPrev, false);
        };
    }, [searchList]);

    useEffect(() => {
        setSerchList();
        setTabView();
    }, []);

    useEffect(() => {
        dispatch({ type: SEARCH_LIST_FOCUS_CLEAR });
    }, [searchLayer, searchLayerTab]);

    const searchListPrev = (event) => {
        if (!event || !event.target.id) return;
        if (event.key === 'Tab' && event.shiftKey) {
            let list = [];
            let insertList = '';
            if (event.target.id === 'search_list_delete_button' && searchLayerTab === 'latest') {
                list = [...searchList];
                insertList = SEARCH_LIST_INSERT;
            } else if (event.target.id === 'searchSaveControl' && searchLayerTab === 'auto') {
                list = [...autoList];
                insertList = SEARCH_AUTO_LIST_INSERT;
            } else {
                return;
            }
            let searchText = '';
            let clone = [...list];
            clone = clone.map((v) => ({ ...v, focus: false }));
            clone[list.length - 1].focus = true;
            searchText = list[list.length - 1].s;

            setTimeout(() => {
                dispatch({
                    type: insertList,
                    data: clone,
                });
                dispatch({
                    type: SEARCH_WORD,
                    data: searchText,
                });
            }, 0);
        } else if (event.key === 'Tab' && !event.shiftKey && event.target.id === 'autoCompleteControl') {
            setTimeout(() => {
                const searchBar = document.querySelector('.search_input');
                searchBar.focus();
                dispatch({
                    type: SEARCH_LAYER,
                    data: false,
                });
            }, 0);
        }
    };

    const setSerchList = () => {
        const data = getCookie('searchList');
        if (data) {
            const decodeData = JSON.parse(data);
            dispatch({
                type: SEARCH_LIST_INSERT,
                data: decodeData,
            });
        }
    };

    const setTabView = () => {
        const data = getCookie('searchTabView');
        if (data) {
            const decodeData = JSON.parse(data);
            dispatch({
                type: SEARCH_LAYER_TAB_VIEW,
                data: decodeData,
            });
        }
    };

    const onClickOutSide = useCallback(() => {
        dispatch({
            type: SEARCH_LAYER,
            data: false,
        });
    }, []);

    const onClickListClear = useCallback(() => {
        setTimeout(() => {
            dispatch({
                type: SEARCH_LIST_INSERT,
                data: [],
            });
            setCookie('searchList', null, -1, '/', `.pping.${process.env.REACT_APP_TLD}`);
        }, 0);
    }, []);

    const onClickTab = useCallback(
        (data) => () => {
            const searchBar = document.querySelector('.search_input');
            searchBar.focus();
            dispatch({
                type: SEARCH_LAYER_TAB,
                data,
            });
        },
        [],
    );

    const tabViewControl = useCallback((data) => () => {
        const searchTabView = { ...searchLayerTabView };
        searchTabView[data] = !searchTabView[data];

        //insert
        setCookie(
            'searchTabView',
            JSON.stringify(searchTabView),
            30 * 24 * 60 * 60,
            '/',
            `.pping.${process.env.REACT_APP_TLD}`,
        );
        dispatch({
            type: SEARCH_LAYER_TAB_VIEW,
            data: searchTabView,
        });
    });

    const highlightText = useCallback(
        (text) => {
            const temp1 = searchWordHighlight.replace(/\s/gi, '');
            const re = `${temp1.split('').join('\\s')}\\s`;
            const re2 = re.replace(/[\\^$*+?.():=!|{},[\]]/g, '\\$&');

            return text.replace(new RegExp(`(${re2})`, 'gi'), '<span class="highlight">$1</span>');
        },
        [searchWordHighlight],
    );

    const onClickLatestDelete = useCallback(
        (data) => () => {
            dispatch({
                type: SEARCH_LATEST_DELETE,
                data,
            });
        },
        [],
    );

    const latestUnitDelete = useCallback(
        (id) => () => {
            const list = [...searchList];
            const deleteList = list.filter((v) => v.id !== id);

            setTimeout(() => {
                // 클릭시 outside보다 먼저실행되는 이슈. 실행컨텍스트 뒤로처리
                setCookie(
                    'searchList',
                    JSON.stringify(deleteList),
                    30 * 24 * 60 * 60,
                    '/',
                    `.pping.${process.env.REACT_APP_TLD}`,
                );
                dispatch({
                    type: SEARCH_LIST_INSERT,
                    data: deleteList,
                });
            }, 0);
        },
        [searchList],
    );

    const onMouseList = useCallback(
        (index) => () => {
            let list = [];
            let insertList = '';
            if (searchLayerTab === 'latest') {
                list = [...searchList];
                insertList = SEARCH_LIST_INSERT;
            } else if (searchLayerTab === 'popular') {
                list = [...popularList];
                insertList = SEARCH_POPULAR_LIST_INSERT;
            } else if (searchLayerTab === 'auto') {
                list = [...autoList];
                insertList = SEARCH_AUTO_LIST_INSERT;
            } else {
                return;
            }
            let clone = list.map((v) => ({ ...v, focus: false }));
            clone[index].focus = true;

            dispatch({
                type: insertList,
                data: clone,
            });
        },
        [searchList, popularList, autoList],
    );

    const onClickList = (searchWord) => () => {
        dispatch({
            type: SEARCH_WORD,
            data: searchWord,
        });
        dispatch({
            type: SEARCH_LAYER,
            data: false,
        });
        onSearch(searchWord);
    };

    const attachQueryString = () => {
        if(search.includes('ad_code')){
            const queryStringAdCode = new URLSearchParams(search).get('ad_code')
            if(queryStringAdCode === 'dap022'){
                return search
            }
        }
        return ''
    }

    return (
        <>
            {searchLayer && (
                <OutSide action={onClickOutSide}>
                    <>
                        <div className="head_frame">
                            {searchLayerTab !== 'auto' && (
                                <div className="tab">
                                    <button
                                        className={searchLayerTab === 'latest' ? 'on' : ''}
                                        onClick={onClickTab('latest')}
                                        disabled={searchLayerTab === 'latest' ? 'disabled' : ''}
                                    >
                                        최근 검색어
                                    </button>
                                    <button
                                        className={searchLayerTab === 'popular' ? 'on' : ''}
                                        onClick={onClickTab('popular')}
                                        disabled={searchLayerTab === 'popular' ? 'disabled' : ''}
                                    >
                                        인기 검색어
                                    </button>
                                </div>
                            )}
                            {searchLayerTab === 'latest' &&
                                (searchLayerTabView.latest ? (
                                    searchList.length > 0 ? (
                                        <ul className="top">
                                            {searchList.map((v, i) => (
                                                <li
                                                    key={v.id}
                                                    className={v.focus ? 'on' : ''}
                                                    onMouseEnter={onMouseList(i)}
                                                >
                                                    <a href={null} className="txt" onClick={onClickList(v.s)}>
                                                        {v.s}
                                                    </a>
                                                    {searchLatestDelete ? (
                                                        <button onClick={latestUnitDelete(v.id)}>
                                                            <i className="icon-close" />
                                                        </button>
                                                    ) : (
                                                        <a href={null} className="date">
                                                            {v.d}
                                                        </a>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <div className="top none_list">최근 검색어 내역이 없습니다.</div>
                                    )
                                ) : (
                                    <div className="top none_list">
                                        <p className="center">
                                            검색어저장 기능이 꺼져 있습니다.
                                            <br />
                                            사용을 원하면 <strong>검색어저장 켜기</strong>를 클릭해 주세요.
                                        </p>
                                    </div>
                                ))}
                            {searchLayerTab === 'popular' &&
                                (popularList.length > 0 ? (
                                    <ul className="top">
                                        {popularList.map((v, i) => (
                                            <li key={i} className={v.focus ? 'on' : ''} onMouseEnter={onMouseList(i)}>
                                                <a href={null} className="txt" onClick={onClickList(v.key)}>
                                                    <span className="rank">{i + 1}</span>
                                                    {v.key}
                                                </a>
                                                <span className={`diff diff_${v?.diff}`} />
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div className="top none_list">인기 검색어가 없습니다.</div>
                                ))}
                            {searchLayerTab === 'auto' &&
                                (searchLayerTabView.auto ? (
                                    autoList.length > 0 ? (
                                        <ul className="top">
                                            {autoList.map((v, i) => (
                                                <li
                                                    key={i}
                                                    className={v.focus ? 'on' : ''}
                                                    onMouseEnter={onMouseList(i)}
                                                >
                                                    <a
                                                        href={null}
                                                        className="txt"
                                                        onClick={onClickList(v.key)}
                                                        dangerouslySetInnerHTML={{ __html: highlightText(v.key) }}
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <div className="top none_list">해당 단어 관련 추천어가 없습니다.</div>
                                    )
                                ) : (
                                    <div className="top none_list">
                                        <p className="center">
                                            자동완성 기능이 꺼저 있습니다.
                                            <br />
                                            사용을 원하면 <strong>자동완성 켜기</strong>를 클릭해 주세요.
                                        </p>
                                    </div>
                                ))}
                            {searchLayerTab !== 'popular' && (
                                <div className="under">
                                    {searchLayerTab !== 'auto' && searchList.length > 0 && (
                                        <button
                                            id="search_list_delete_button"
                                            tabIndex="1"
                                            onClick={searchLatestDelete ? onClickListClear : onClickLatestDelete(true)}
                                        >
                                            {searchLatestDelete ? '기록 전체 삭제' : '기록 삭제'}
                                        </button>
                                    )}
                                    {searchLatestDelete ? (
                                        <>
                                            <button
                                                className="left_auto"
                                                onClick={onClickLatestDelete(false)}
                                                tabIndex="1"
                                            >
                                                완료
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="left_auto pr9 dash"
                                                onClick={tabViewControl('latest')}
                                                tabIndex="1"
                                                id="searchSaveControl"
                                            >
                                                검색어저장 {searchLayerTabView.latest ? '끄기' : '켜기'}
                                            </button>
                                            <button
                                                className="pl9"
                                                onClick={tabViewControl('auto')}
                                                tabIndex="1"
                                                id="autoCompleteControl"
                                            >
                                                자동완성 {searchLayerTabView.auto ? '끄기' : '켜기'}
                                            </button>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="adv_search_frame">
                            <iframe src={`${process.env.REACT_APP_AD_URL}/dap022` + attachQueryString()} title="search ad" />
                        </div>
                    </>
                </OutSide>
            )}
        </>
    );
};

export default AutoFrame;



// WEBPACK FOOTER //
// ./src/header/component/search/autoFrame.js